import { cn } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import NextLink from 'next/link';
import { buildMagazinePageHref } from '../helpers/buildMagazinePageHref';

type ArticleAuthorProps = {
  name: string;
  /** When absent, the author name is rendered without a link (no locale author page). */
  authorSlug: string | undefined;
  className?: string;
};

function ArticleAuthor({ name, authorSlug, className }: ArticleAuthorProps) {
  const t = useTranslations('magazine.article');

  return (
    <address className={cn('flex items-center gap-4 not-italic', className)} data-testid="article-author" data-track-name="Author" data-track-provider={name}>
      <span
        className="bg-accent-green text-foreground dark:text-foreground-inverse paragraph-strong flex size-10 shrink-0 items-center justify-center rounded-full"
        aria-hidden="true"
        data-testid="article-author-avatar"
      >
        {name.charAt(0).toUpperCase()}
      </span>
      <span className="paragraph text-foreground">
        {t.rich('by_author', {
          name,
          link: chunks =>
            authorSlug ? (
              <NextLink href={buildMagazinePageHref({ type: 'author', authorSlug }, 1)} className="paragraph-strong hover:underline" data-testid="article-author-link">
                {chunks}
              </NextLink>
            ) : (
              <span className="paragraph-strong" data-testid="article-author-name">
                {chunks}
              </span>
            ),
        })}
      </span>
    </address>
  );
}

export { ArticleAuthor, type ArticleAuthorProps };
